module.exports = __webpack_public_path__ + "static/media/active-days-video.4a70c40f.mp4";